<app-strategies-list [userType]="'public'"></app-strategies-list>